<template>
  <div class="card card-custom gutter-b">
    <div class="card-header d-flex justify-content-between">
      <div class="card-title">
        <h3 class="card-label">Điểm danh học viên ca thi {{ examName }}</h3>
      </div>
    </div>
    <div v-loading="loading" class="card-body display-grid">
      <div
          style="
          background: #ebf4fd;
          padding: 8px;
          border-radius: 8px;
          border: 1px solid gray;
          width: 100%;
        "
      >
        <div style="width: 100%; display: flex; justify-content: space-between">
          <span style="font-size: 24px; font-weight: 500">Danh sách học viên</span>
          <el-button type="primary" style="color: white" :disabled="isExport" @click="exportExcel">Xuất excel</el-button>
        </div>
        <hr/>
        <div class="table-container">
          <div class="table-header">
            <div class="col">Họ và tên</div>
            <div class="col">Mã học viên</div>
            <div v-if="!isEntrance" class="col">Mã lớp</div>
            <div class="col">Mã dự thi</div>
            <div class="col">Loại thi</div>
            <div class="col">Trạng thái</div>
          </div>
          <div v-if="dataTable.length > 0" style="overflow-y: auto; height: 450px;">
            <div v-for="(item, index) in dataTable"
                 :key="index"
                 :class="studentIndex === index ? 'table-row__active' : ''"
                 class="table-row" @click="handleSelectStudent(item, index)">
              <div class="col">{{ item.name }} - {{ item.phone }}</div>
              <div class="col">{{ item.studentId }}</div>
              <div v-if="!isEntrance" class="col">{{ item?.classroomName }}</div>
              <div class="col">{{ item?.examCode }}</div>
              <div class="col">{{ item?.type }}</div>
              <div class="col">
                <template v-if="item.status === PRESENT">
                  <i class="el-icon-check" style="color: #159400"/>
                  <span class="text-success">Có mặt</span>
                </template>
                <template v-else-if="item.status === ABSENT">
                  <i class="el-icon-close" style="color: #ff0000"/>
                  <span class="text-danger">Vắng mặt</span>
                </template>
                <template v-else-if="item.status === NEED_ADDITIONAL && isShowAdditional">
                  <i class="el-icon-warning" style="color: #e6a23c"/>
                  <span class="text-warning">Cần bổ sung</span>
                </template>
                <template v-else-if="item.status === TAKE_ATTENDANCE">
                  <i class="el-icon-edit" style="color: #0066ff"/>
                  <span style="color: #0066ff">Đang điểm danh</span>
                </template>
                <template v-else>
                  <el-button
                      size="mini"
                      style="color: white; background: #0763b6"
                      type="primary"
                  >Điểm danh
                  </el-button>
                </template>
              </div>
            </div>
          </div>
          <div
              v-else
              style="
              color: black;
              width: 100%;
              display: flex;
              justify-content: center;
            "
          >
            Không có dữ liệu
          </div>
        </div>
      </div>
      <div
          style="
          background: #ebf4fd;
          padding: 15px;
          border-radius: 8px;
          border: 1px solid gray;
          width: 100%;
        "
      >
        <span style="font-weight: 700; padding: 5px 0; display: block"
        >HỌC VIÊN: {{ studentSelected?.name }}</span
        >
        <hr/>
        <div style="">
          <div class="margin-bottom: 10px; border rounded-lg overflow-hidden">
            <el-image class="d-flex align-items-center justify-content-center" style="width: 100%; height: 400px"
                      :src="studentSelected?.studentImage" lazy>
              <div slot="error" class="image-slot block" style="width: 100%">
                <div class="d-flex align-items-center flex-column justify-content-center">
                  <i style="font-size: 40px" class="el-icon-picture-outline"></i>
                  Chưa có ảnh
                </div>
              </div>
            </el-image>
          </div>
          <p style="margin-top: 10px; margin-bottom: 10px; font-size: 16px; font-weight: 400">Chọn trạng thái điểm
            danh:</p>
          <div style="margin-top: 10px;  display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 10px">
            <el-button
                :disabled="disableAction"
                style="color: white"
                type="primary"
                @click="handleAttendance(PRESENT)"
            >
              Có mặt
            </el-button>
            <el-button
                :disabled="disableAction"
                style="color: white"
                type="warning"
                @click="handleAttendance(NEED_ADDITIONAL)"
            >Cần chụp lại thông tin
            </el-button>
            <el-button
                :disabled="disableAction"
                style="color: white"
                type="danger"
                @click="openAbsentDialog"
            >
              Vắng mặt
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Dialog xác nhận vắng mặt -->
    <el-dialog
        title="Xác nhận vắng mặt"
        :visible.sync="absentDialogVisible"
        width="500px"
        :close-on-click-modal="false"
        @close="resetAbsentDialog"
    >
      <div class="absent-dialog-content">
        <p style="font-size: 15px; margin-bottom: 16px;">
          Học viên: <strong>{{ studentSelected?.name }}</strong>
        </p>

        <p style="font-size: 14px; font-weight: 600; margin-bottom: 10px;">Loại vắng mặt:</p>
        <el-radio-group v-model="absenceType" style="margin-bottom: 16px;">
          <el-radio :label="ABSENCE_EXCUSED">Có phép</el-radio>
          <el-radio :label="ABSENCE_UNEXCUSED">Không phép</el-radio>
        </el-radio-group>

        <div v-if="absenceType === ABSENCE_EXCUSED" style="margin-top: 12px;">
          <p style="font-size: 14px; font-weight: 600; margin-bottom: 8px;">
            Lý do vắng <span style="color: #f56c6c">*</span>
          </p>
          <el-input
              v-model="absenceReason"
              type="textarea"
              :rows="3"
              :maxlength="200"
              show-word-limit
              placeholder="Nhập lý do vắng mặt (tối đa 200 ký tự)"
          ></el-input>
          <p v-if="absenceReasonError" style="color: #f56c6c; font-size: 12px; margin-top: 4px;">
            {{ absenceReasonError }}
          </p>
        </div>

        <div v-if="absenceType === ABSENCE_UNEXCUSED" style="margin-top: 12px;">
          <el-alert
              title="Lưu ý"
              type="warning"
              :closable="false"
              show-icon
          >
            <span>Học viên sẽ không được chọn ngày thi khác. Hệ thống sẽ tự động cập nhật điểm tất cả các kĩ năng thi là 0 điểm.</span>
          </el-alert>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="absentDialogVisible = false">Hủy</el-button>
        <el-button
            type="danger"
            :disabled="absenceType === null"
            :loading="absentSubmitting"
            @click="confirmAbsent"
        >
          Xác nhận
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {ABSENT, ATTENDANCE, AttendanceModel, NEED_ADDITIONAL, PRESENT, TAKE_ATTENDANCE,} from "../model/taskPersonal";
import {
    EXPORT_STUDENT_INFO,
    GET_LIST_STUDENT_ATTENDANCE,
    MAKING_EXAM_ATTENDANCE,
} from "@/core/services/store/marking/marking.module";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {exportExcel} from "@/core/filters";

export default {
  name: "AttendanceList",
  data() {
    return {
      loading: true,
      PRESENT,
      ABSENT,
      NEED_ADDITIONAL,
      TAKE_ATTENDANCE,
      ATTENDANCE,
      ABSENCE_EXCUSED: 0,
      ABSENCE_UNEXCUSED: 1,
      studentSelected: null,
      dataTable: [],
      studentIndex: 0,
      examName: null,
      isExport: false,
      absentDialogVisible: false,
      absenceType: null,
      absenceReason: '',
      absenceReasonError: '',
      absentSubmitting: false,
    };
  },
  watch: {
    studentSelected: {
      handler(val) {
        if (!val) return;
        this.studentAttendanceUpdate();
      },
      deep: true
    },
    absenceType(val) {
      if (val !== 0) {
        this.absenceReason = '';
        this.absenceReasonError = '';
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Điểm danh học viên", name: "AttendanceList"},
      {title: "Danh sách tác vụ", name: "PersonalTaskList"},
    ]);
    this.getListStudent();
  },
  computed: {
    disableAction() {
      return this.dataTable.length === 0;
    },
    isEntrance() {
      const {isEntrance} = this.$route.query;
      return isEntrance === true || isEntrance === "true";
    },
    isShowAdditional() {
      return this.$route.query.exam_form && +this.$route.query.exam_form === 1
    }
  },
  methods: {
    getListStudent() {
      this.$store
          .dispatch(GET_LIST_STUDENT_ATTENDANCE, {
            marking_exam_shift_id: this.$route.params.id,
          })
          .then((res) => {
            if (!res.error) {
              this.dataTable =
                  res.data.map((item) => new AttendanceModel(item)) ?? [];
              this.examName = res.data[0]?.shift_name ?? "";
              this.studentSelected = this.dataTable[this.studentIndex] ?? {};
            }
          })
          .catch((e) => {
            console.log(e, "error");
          })
          .finally(() => {
            this.loading = false;
          });
    },
    studentAttendanceUpdate() {
        // this.$echo
        //     .channel(`after-student-verify-image-${this.studentSelected?.userId}`)
        //     .listen("Academic\\AfterStudentVerifyEvent", (payload) => {
        //       const userId = payload?.data?.user_id;
        //       const imageUrl = payload?.data?.verification_image_url;
        //       this.dataTable.map((item) => {
        //         if (item.userId === userId) {
        //           item.studentImage = imageUrl;
        //           item.status = TAKE_ATTENDANCE;
        //         }
        //       });
        //       if (this.studentSelected?.user_id === userId) {
        //         this.studentSelected.studentImage = imageUrl
        //       }
        //     });
    },
    handleSelectStudent(student, index) {
      this.studentSelected = student;
      this.studentIndex = index;
    },
    openAbsentDialog() {
      this.resetAbsentDialog();
      this.absentDialogVisible = true;
    },
    resetAbsentDialog() {
      this.absenceType = null;
      this.absenceReason = '';
      this.absenceReasonError = '';
      this.absentSubmitting = false;
    },
    confirmAbsent() {
      if (this.absenceType === 0 && !this.absenceReason.trim()) {
        this.absenceReasonError = 'Vui lòng nhập lý do vắng mặt';
        return;
      }
      this.absenceReasonError = '';
      this.absentSubmitting = true;

      const payload = {
        status: ABSENT,
        marking_exam_retake: this.studentSelected.id,
        user_id: this.studentSelected.userId,
        absence_type: this.absenceType,
      };

      if (this.absenceType === 0) {
        payload.absence_reason = this.absenceReason.trim();
      }

      this.$store
          .dispatch(MAKING_EXAM_ATTENDANCE, payload)
          .then((res) => {
            if (!res.error) {
              const message = this.absenceType === 0
                  ? 'Điểm danh vắng có phép thành công !'
                  : 'Điểm danh vắng không phép thành công !';
              this.$message.success(message);
              this.absentDialogVisible = false;
              this.studentIndex +=
                  this.dataTable.length > 0 &&
                  this.dataTable.length > this.studentIndex + 1
                      ? 1
                      : 0;
              this.getListStudent();
            }
          })
          .catch((e) => {
            this.$message.error(e?.data?.message || 'Điểm danh thất bại !');
          })
          .finally(() => {
            this.absentSubmitting = false;
          });
    },
    handleAttendance(status) {
      const payload = {
        status: status,
        marking_exam_retake: this.studentSelected.id,
        user_id: this.studentSelected.userId,
      };
      this.$store
          .dispatch(MAKING_EXAM_ATTENDANCE, payload)
          .then((res) => {
            if (!res.error) {
              this.$message.success("Điểm danh học viên thành công !");
              this.studentIndex +=
                  this.dataTable.length > 0 &&
                  this.dataTable.length > this.studentIndex + 1
                      ? 1
                      : 0;
              this.getListStudent();
            }
          })
          .catch((e) => {
            console.log(e, "making exam attendance error !");
          });
    },
    exportExcel() {
      this.isExport = true;
      const HEADER_ROW_EXPORT_INFO_EXAM = [
        {
          key: 'name',
          value: 'Họ tên',
        },
        {
          key: 'studentId',
          value: 'Mã học viên',
        },

        {
          key: 'classroom_name',
          value: 'Tên lớp',
        },

        {
          key: 'phone',
          value: 'Số điện thoại',
        },
        {
          key: 'examCode',
          value: 'Mã dự thi',
        },
        {
          key: 'type',
          value: 'Loại thi',
        },

        ...(this.isEntrance
          ? [
            {
              key: 'status',
              value: 'Trạng thái điểm danh',
            },
            {
              key: 'reason',
              value: 'Lý do vắng',
            },
          ]
          : []),
      ];
      this.$store.dispatch(EXPORT_STUDENT_INFO, { marking_exam_shift_id: this.$route.params.id }).then((res) => {
        if (res.error) {
          this.$bvToast.toast(res.message ?? 'Export dữ liệu thất bại !', {
            title: 'Export excel',
            variant: 'danger',
            solid: true
          });
        } else {
          const data = res.data.map((item) => {
            return {
              name: item?.user_name ?? '',
              studentId: item.user_id ? item?.user_id + 100000 : '',
              classroom_name: item?.classroom_name ?? '',
              phone: item?.user_phone ?? '',
              examCode: item?.exam_code ?? '',
              type: item?.type_label ?? '',
              status: item?.status,
              reason: item?.reason
            }
          }) ?? []
          exportExcel(HEADER_ROW_EXPORT_INFO_EXAM, data, "Danh sách thông tin ca thi.xlsx", false)
          this.$bvToast.toast(res.message ?? 'Export dữ liệu thành công !', {
            title: 'Export excel',
            variant: 'success',
            solid: true
          });
        }
      }).catch(e => {
        console.log(e, 'Export attendance list error !')
      }).finally(() => {
        this.isExport = false
      });
    },
  },
};
</script>

<style scoped>
.display-grid {
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 20px;
}

.table-container {
  width: 100%;
  border-radius: 8px;
  overflow-x: auto;
  font-size: 14px;
}

.table-header,
.table-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr;
  padding: 12px 16px;
  align-items: center;
}

.table-header {
  font-weight: bold;
}

.table-row {
  background-color: white;
  border-radius: 5px;
  margin-bottom: 10px;
}

.table-row__active {
  border: 1px solid green;
}

.table-row:hover {
  background-color: #f0f9ff;
}

.col {
  overflow-wrap: break-word;
}

.text-success {
  color: #67c23a;
}

.text-danger {
  color: #f56c6c;
}

.text-warning {
  color: #e6a23c;
}

.text-info {
  color: #409eff;
}

.absent-dialog-content {
  padding: 0 10px;
}

@media (max-width: 1028px) {
  .display-grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

@media (max-width: 768px) {
  .display-grid {
    grid-template-columns: 1fr;
  }

  .table-header,
  .table-row {
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: auto;
    flex-direction: column;
    gap: 4px;
  }

  .col:nth-child(3),
  .col:nth-child(4) {
    display: none;
  }
}
</style>
